import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function EnrichmentError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot generate Enrichment Dashboard'}
    </Alert>
  );
}

export { EnrichmentError };
